import { useQuery } from '@tanstack/react-query';

import { PrependUrl } from 'enums';
import { fetchWithCsrfToken } from 'utils/fetchWrapper';

export interface UserDetails {
  first_name: string;
  last_name: string;
  initials: string;
  email: string;
  photo_url?: string;
  company_rank: string;
  company: {
    id: string;
    name: string;
    created_at: string;
    company_type: string;
  };
}

type UserDetailsResponse = UserDetails | null;

const useGetUserDetails = () => {
  const { data, isLoading, isError } = useQuery<UserDetailsResponse, Error>(
    ['getUserDetails'],
    async () =>
      fetchWithCsrfToken<UserDetailsResponse>(
        `${PrependUrl.ASYNC}/user/get_details`,
        'POST'
      )
  );

  return {
    data,
    isLoading,
    isError,
  };
};

export default useGetUserDetails;
